/**
 * Rule 5: Remove leaf rows that are visually identical across all currently
 * visible data columns.
 *
 * Leaf rows show nothing in the grouping column, so two leaves are
 * indistinguishable to the user iff their visible data-column values are
 * identical. The first occurrence of each unique combination is kept;
 * subsequent duplicates are removed. MUI will create no group node for an
 * empty-after-dedup branch.
 */
export function deduplicateRows<T extends object>(
  rows: T[],
  visibleFieldKeys: string[]
): T[] {
  if (rows.length === 0) return rows;
  const seen = new Set<string>();
  return rows.filter(row => {
    const r = row as Record<string, unknown>;
    // Use NUL as separator — safe since field values never contain NUL.
    const key = visibleFieldKeys.map(f => String(r[f] ?? '')).join('\u0000');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
